var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
import AccoutCheckService from '../../../api/AccoutCheckService';
import BindedStoreService from "../../../api/UserService";
import LeftTree from './LeftTree';
import TabTable from './TabTable.vue';
import _ from 'lodash';
var EActiveType;
(function (EActiveType) {
    EActiveType["UN_SELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddGoods = (function (_super) {
    __extends(AddGoods, _super);
    function AddGoods() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tabTableComponent = 'tab-table';
        _this.treeData = [];
        _this.tableData = [];
        _this.total = 0;
        _this.pagerCount = 5;
        _this.curGoodNode = {};
        _this.activeName = '0';
        _this.selectRows = [];
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.canFreshTable = true;
        _this.formData = {};
        return _this;
    }
    AddGoods.prototype.created = function () {
        console.log('this.tabTableComponent');
        console.log(this.tabTableComponent);
        this.storeListService = AccoutCheckService.getInstance();
        this.bindedStoreService = BindedStoreService.getInstance();
        this.selecedStore();
    };
    AddGoods.prototype.mounted = function () {
    };
    AddGoods.prototype.gitRightList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        var params = {
            keyword: this.formData.keyword
        };
        if (this.curGoodNode && this.curGoodNode.business_id != '-1') {
            params = Object.assign({}, params, {
                business_id: this.curGoodNode.business_id
            });
        }
        var shop_ids;
        shop_ids = (this.selectedList || []).map(function (item) {
            return item.shop_id;
        });
        console.log(888, shop_ids);
        this.storeListService.getShopAny(Object.assign({}, params, {
            is_not_in: Array.isArray(shop_ids) ? shop_ids.join(',') : shop_ids
        }, pager)).then(function (res) {
            if (res.data.success) {
                _this.setSelected(true);
                var DATA = Array.isArray(res.data.data) ? res.data.data : [];
                _this.unSelectList = DATA.filter(function (item) {
                    return item.shop_id !== -1;
                });
                _this.total = res.data.total;
            }
        }, function (err) {
            _this.$message.error(err.message);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddGoods.prototype.selecedStore = function () {
        var _this = this;
        if (this.account_id.length > 1) {
            return;
        }
        var params = {
            account_id: Array.isArray(this.account_id) ? this.account_id.join() : this.account_id,
        };
        this.getLeftTree();
        this.bindedStoreService.getbindedStore(Object.assign({}, params, { limit: 10000 })).then(function (res) {
            console.log(666, res.data);
            _this.selectedList = Array.isArray(res.data.data) ? res.data.data : [];
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    AddGoods.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), 'shop_id');
        var isUnselectAll = !currentSelectRows.length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (shop) { return shop.shop_id === currentRow.shop_id; })) {
            _.remove(this.selectedList, function (shop) { return shop.shop_id === currentRow.shop_id; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item.shop_id === good.shop_id; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
            var pagination = _this.$refs.pagination;
            _this.gitRightList(pagination.getPage());
        });
    };
    AddGoods.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!this.selectedList.length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var item_1 = _.find(_this.unSelectList, function (current) { return current.shop_id === good.shop_id; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    AddGoods.prototype.getLeftTree = function () {
        var _this = this;
        this.storeListService.getGroupchilds().then(function (res) {
            _this.treeData = Array.isArray(res.data.data) ? res.data.data : [];
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddGoods.prototype.search = function () {
        var pagination = this.$refs.pagination;
        pagination.clear();
        this.gitRightList();
    };
    AddGoods.prototype.close = function () {
        this.$closeDialog();
        this.$emit('closeDiolog', false);
    };
    AddGoods.prototype.save = function () {
        var data = _.uniqBy(this.selectedList, 'shop_id');
        var shopids = [];
        data.forEach(function (item) {
            shopids.push(item.shop_id);
        });
        var AllData = {
            data: shopids,
            account: this.account_id
        };
        console.log(666, this.account_id);
        this.$emit('save:ok', AllData);
    };
    AddGoods.prototype.nodeClick = function (node) {
        this.curGoodNode = node || null;
        this.gitRightList();
    };
    AddGoods.prototype.pageChange = function (pager) {
        this.gitRightList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    __decorate([
        Prop({
            type: Object
        })
    ], AddGoods.prototype, "imageItem", void 0);
    AddGoods = __decorate([
        Component({
            components: {
                'left-tree': LeftTree,
                'tab-table': TabTable,
            }
        })
    ], AddGoods);
    return AddGoods;
}(VueDialog));
export default AddGoods;
